import { Badge } from '@kerfjs/ui/badge';
import { type SafeHtml } from 'kerfjs';

type MemberStatusTone = 'success' | 'warning' | 'danger' | 'neutral';

/** The header badge for a member's status: Active, Invitation pending, Suspended, or the raw status. */
export function memberStatusBadge(status: string): { label: string; tone: MemberStatusTone } {
  if (status === 'active') return { label: 'Active', tone: 'success' };
  if (status === 'invited') return { label: 'Invitation pending', tone: 'warning' };
  if (status === 'suspended') return { label: 'Suspended', tone: 'danger' };
  return { label: status, tone: 'neutral' };
}

/**
 * A member status badge for the dialog's header actions (HS2-D03JYH).
 */
export function MemberStatusGroup({ status }: { status: string }): SafeHtml {
  const badge = memberStatusBadge(status);
  return (
    <Badge tone={badge.tone} rootAttributes={{ 'data-member-status': status }}>
      {badge.label}
    </Badge>
  );
}
